import { classNames } from 'helpers/validation';
import { FormattedMessage } from 'react-intl';

interface PaymentBadgeProps {
  name: string;
}

const badgeStyle = {
  preparation: 'bg-gray-50 text-gray-600 ring-gray-500/10',
  freetrial: 'bg-yellow-50 text-yellow-800 ring-yellow-600/20',
  inactive: 'bg-indigo-50 text-indigo-700 ring-indigo-700/10',
  active: 'bg-green-50 text-green-700 ring-green-600/20',
  pastdue: 'bg-orange-50 text-orange-700 ring-orange-600/20',
  cancel: 'bg-red-50 text-red-700 ring-red-600/10',
};

export const PaymentBadge = ({ name }: PaymentBadgeProps) => {
  return (
    <span
      className={classNames(
        badgeStyle[name as keyof typeof badgeStyle],
        'inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset',
      )}
    >
      <FormattedMessage id={name} />
    </span>
  );
};
